import React, { useEffect, useState } from 'react';
import { apiFetch } from '../../auth/paymentsApi';
import { orderText as t } from './orderManagementText';
export const remainingTime = (deadline, now) => {
  const end = new Date(deadline).getTime();
  if (!deadline || !Number.isFinite(end)) return null;
  const minutes = Math.max(0, Math.ceil((end - now) / 60000));
  return `${Math.floor(minutes / 1440)}d ${Math.floor(minutes % 1440 / 60)}h ${minutes % 60}m`;
};
const OrderPendingTimer = ({ line }) => {
  const [now, setNow] = useState(Date.now());
  const [enabled, setEnabled] = useState(false);
  const [offset, setOffset] = useState(0);
  const deadline = line?.orderManagement?.autoCancelAt;
  const pending = line?.status === 'Not processed' && (!line.sellerDecision?.status || line.sellerDecision.status === 'pending') && !['captured','capturing','capture_pending','canceled'].includes(line.payment?.status || line.paymentStatus);
  useEffect(() => {
    if (!pending || !deadline) return;
    let active = true;
    const refresh = () => apiFetch('/orders/automation-display').then(data => { if (!active) return; const localNow = Date.now(); setNow(localNow); setEnabled(data.autoCancelEnabled); setOffset(new Date(data.serverNow).getTime() - localNow); }).catch(() => { if (active) setEnabled(false); });
    refresh(); const interval = setInterval(() => { setNow(Date.now()); refresh(); }, 60000);
    return () => { active = false; clearInterval(interval); };
  }, [pending, deadline]);
  const remaining = remainingTime(deadline, now + offset);
  if (!pending || !enabled || !remaining) return null;
  return <p role="timer" aria-live="off" className="wb__hint">{new Date(deadline).getTime() <= now + offset ? t('expired') : `${t('remaining')}: ${remaining}`}</p>;
};
export default OrderPendingTimer;
